import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const HighChairIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "HighChairIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.49133 8.94437H11.9088V13.9193H8.75346C8.40495 13.9193 8.1224 14.2019 8.1224 14.5504C8.1224 14.8989 8.40495 15.1814 8.75346 15.1814H11.9088V18.5831L7.20912 20.9329C6.94736 21.0638 6.80991 21.3575 6.87714 21.6423C6.94441 21.9272 7.19865 22.1284 7.49133 22.1284H17.5883C17.881 22.1284 18.1353 21.9272 18.2025 21.6423C18.2698 21.3575 18.1324 21.0638 17.8705 20.9329L13.1709 18.5831V15.1814H16.3262C16.6747 15.1814 16.9573 14.8989 16.9573 14.5504C16.9573 14.2019 16.6747 13.9193 16.3262 13.9193H13.1709V8.94437H14.433V10.8376C14.433 11.1861 14.7156 11.4686 15.0641 11.4686H18.8505C19.199 11.4686 19.4815 11.1861 19.4815 10.8376C19.4815 10.4891 19.199 10.2065 18.8505 10.2065H15.6952V8.94437H17.5883C18.6322 8.94437 19.4815 8.09509 19.4815 7.05118V4.48486C19.4815 3.44096 18.6323 2.59167 17.5883 2.59167H7.49133C6.44743 2.59167 5.59814 3.44095 5.59814 4.48486V7.05118C5.59814 8.09508 6.44742 8.94437 7.49133 8.94437ZM10.1646 20.8663L12.5398 19.6787L14.9151 20.8663H10.1646ZM6.86027 4.48486C6.86027 4.13689 7.14336 3.8538 7.49133 3.8538H17.5883C17.9363 3.8538 18.2194 4.13689 18.2194 4.48486V7.05118C18.2194 7.39915 17.9363 7.68224 17.5883 7.68224H7.49133C7.14336 7.68224 6.86027 7.39915 6.86027 7.05118V4.48486Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default HighChairIcon;
